<script lang="ts">
    import { getDashboardCtx } from "../state/dashboard.svelte";
    import { translate } from "@/utils/format";
    import { goTo } from "@/utils/router";
    import { Chart, NoData } from "@/components";

    const store = getDashboardCtx();
    import SectionHeader from "../components/SectionHeader.svelte";
    import StripeGate from "../components/StripeGate.svelte";
</script>

<div class="dashStack">
    <SectionHeader id="overview" />
    <div class="referralsPanel">
    {#if store.isStripeConfigured}
<div class="referralsPanel__toolbar">
    <div class="periodBar">
        <span class="periodBar__label">
            {translate("PARTNER_PERIOD", "Periodo")}:
            <strong>{store.rangeDaysLabel}</strong>
        </span>
        <span
            class="periodBar__updated"
            title={store.lastMetricsUpdatedAt
                ? store.formatDateTime(store.lastMetricsUpdatedAt)
                : translate(
                      "PARTNER_LAST_UPDATED_UNKNOWN",
                      "Sin datos todavía",
                  )}
        >
            {#if store.lastMetricsUpdatedAt}
                {translate(
                    "PARTNER_LAST_UPDATED",
                    "Actualizado",
                )}
                {" "}
                {store.relativeTime(store.lastMetricsUpdatedAt)}
            {:else}
                {translate(
                    "PARTNER_LAST_UPDATED_UNKNOWN",
                    "Sin datos todavía",
                )}
            {/if}
        </span>
    </div>
    <div
        class="rangePicker"
        aria-label={translate("PARTNER_PERIOD", "Periodo")}
    >
        <button
            type="button"
            class={store.range === "7d" ? "isActive" : ""}
            onclick={() => {
                store.range = "7d";
                void store.loadMetrics();
            }}
        >
            7
        </button>
        <button
            type="button"
            class={store.range === "30d" ? "isActive" : ""}
            onclick={() => {
                store.range = "30d";
                void store.loadMetrics();
            }}
        >
            30
        </button>
        <button
            type="button"
            class={store.range === "90d" ? "isActive" : ""}
            onclick={() => {
                store.range = "90d";
                void store.loadMetrics();
            }}
        >
            90
        </button>
        <button
            type="button"
            class={store.range === "all" ? "isActive" : ""}
            onclick={() => {
                store.range = "all";
                void store.loadMetrics();
            }}
        >
            {translate("PARTNER_PERIOD_ALL_SHORT", "Total")}
        </button>
    </div>
    <div class="quickActions">
        <button
            class="button --secondary"
            onclick={store.copyLink}
        >
            {translate(
                "PARTNER_COPY_LINK",
                "Copiar enlace",
            )}
        </button>
        <button
            class="button --secondary"
            onclick={store.downloadQR}
            title={translate(
                "PARTNER_DOWNLOAD_QR_HINT",
                "PNG listo para compartir",
            )}
        >
            {translate(
                "PARTNER_DOWNLOAD_QR",
                "Descargar QR",
            )}
        </button>
        <button
            class="button --primary"
            onclick={() => goTo("/creativityGenerator")}
        >
            {translate(
                "PARTNER_CREATIVITIES_OPEN",
                "Crear creatividad",
            )}
        </button>
    </div>
</div>

<div class="kpiGrid">
    <div class="kpi">
        <div class="kpi__value">
            {store.formatCount(store.installs)}
        </div>
        <div class="kpi__label">
            {translate("PARTNER_INSTALLS", "Instalaciones")}
        </div>
    </div>
    <div class="kpi">
        <div class="kpi__value">{store.formatCount(store.signups)}</div>
        <div class="kpi__label">
            {translate("PARTNER_SIGNUPS", "Registros")}
        </div>
    </div>
    <div class="kpi">
        <div class="kpi__value">
            {store.formatCount(store.subscribers)}
        </div>
        <div class="kpi__label">
            {translate(
                "PARTNER_SUBSCRIBERS",
                "Suscriptores",
            )}
        </div>
    </div>
    <div class="kpi">
        <div
            class="kpi__value"
            title={translate(
                "PARTNER_HOW_CALCULATED",
                "Conversión total = suscriptores / instalaciones. Conversión del periodo = suscriptores del periodo / instalaciones del periodo.",
            )}
        >
            {store.formatPercent(store.conversion, 1)}
        </div>
        <div class="kpi__label">
            <span>
                {translate(
                    "PARTNER_CONVERSION_TOTAL",
                    "Conversión total",
                )}
            </span>
            <span class="kpi__subLabel">
                {translate(
                    "PARTNER_CONVERSION_PERIOD",
                    "Conversión del periodo",
                )}:
                <strong
                    >{store.formatPercent(
                        store.conversionRange,
                        1,
                    )}</strong
                >
            </span>
        </div>
    </div>
</div>

<div class="grid2">
    <div class="panelCard">
        <div class="panelCard__title">
            {translate(
                "LANG_PARTNER_CHART_INSTALLS",
                "Instalaciones por día",
            )}
        </div>
        <div class="panelCard__chart">
            {#if store.metricsHasSeries}
                <Chart
                    params={store.installsChart}
                    type="line"
                    chartId="partnerInstallsChart"
                    height={220}
                    currentRange={store.range}
                />
            {:else}
                <NoData
                    params={{
                        icon: "fa-chart-line",
                        title: translate(
                            "LANG_PARTNER_NO_SERIES_TITLE",
                            "Sin datos para este periodo",
                        ),
                        description: translate(
                            "LANG_PARTNER_NO_SERIES_DESC",
                            "Aún no hay datos diarios disponibles.",
                        ),
                    }}
                />
            {/if}
        </div>
        <div class="panelCard__footer">
            <span>
                {translate(
                    "LANG_PARTNER_RANGE_TOTAL",
                    "Total periodo",
                )}: <strong>{store.installsRange}</strong>
            </span>
        </div>
    </div>

    <div class="panelCard">
        <div class="panelCard__title">
            {translate(
                "LANG_PARTNER_CHART_SUBS",
                "Nuevas suscripciones por día",
            )}
        </div>
        <div class="panelCard__chart">
            {#if store.metricsHasSeries}
                <Chart
                    params={store.subsChart}
                    type="bar"
                    chartId="partnerSubsChart"
                    height={220}
                    currentRange={store.range}
                />
            {:else}
                <NoData
                    params={{
                        icon: "fa-chart-bar",
                        title: translate(
                            "LANG_PARTNER_NO_SERIES_TITLE",
                            "Sin datos para este periodo",
                        ),
                        description: translate(
                            "LANG_PARTNER_NO_SERIES_DESC",
                            "Aún no hay datos diarios disponibles.",
                        ),
                    }}
                />
            {/if}
        </div>
        <div class="panelCard__footer">
            <span>
                {translate(
                    "LANG_PARTNER_RANGE_TOTAL",
                    "Total periodo",
                )}: <strong>{store.newSubsRange}</strong>
            </span>
            <span>
                {translate(
                    "LANG_PARTNER_RANGE_CANCELS",
                    "Cancelaciones",
                )}: <strong>{store.cancelsRange}</strong>
            </span>
            <span>
                {translate(
                    "LANG_PARTNER_RANGE_RENEWS",
                    "Renovaciones",
                )}: <strong>{store.renewalsRange}</strong>
            </span>
        </div>
    </div>
</div>

<div class="panelCard">
    <div class="panelCard__title">
        {translate(
            "LANG_PARTNER_ACTIVITY_TITLE",
            "Actividad reciente",
        )}
    </div>
    <div class="activityList">
        {#if store.metricsHasActivity}
            {#each store.activity as a (a.id)}
                <div
                    class={`activityItem activityItem--${a.type}`}
                >
                    <span class="bullet"></span>
                    <span class="text">
                        <span class="primary"
                            >{a.label}</span
                        >
                        {#if a.details}
                            <span class="details"
                                >{a.details}</span
                            >
                        {/if}
                    </span>
                    <span class="time"
                        >{store.relativeTime(a.ts)}</span
                    >
                </div>
            {/each}
        {:else}
            <NoData
                params={{
                    icon: "fa-clock",
                    title: translate(
                        "LANG_PARTNER_NO_ACTIVITY_TITLE",
                        "Sin actividad reciente",
                    ),
                    description: translate(
                        "LANG_PARTNER_NO_ACTIVITY_DESC",
                        "Cuando haya eventos atribuidos a tu enlace aparecerán aquí.",
                    ),
                }}
            />
        {/if}
    </div>
</div>
    {:else}
        <StripeGate />
    {/if}
    </div>
</div>
